import React from 'react';
import { ArrowRight, CalendarDays, Heart, Search, Sparkles } from 'lucide-react';
import { Link } from 'react-router-dom';

const steps = [
  {
    number: '01',
    title: 'Choose your path',
    description: 'Experience, membership, or a 1 on 1 session.',
    icon: Search,
  },
  {
    number: '02',
    title: 'Pick your practitioner or your circle',
    description: 'Every listing is verified and reviewed.',
    icon: CalendarDays,
  },
  {
    number: '03',
    title: 'Show up and transform',
    description: 'Alone or in community, the work meets you where you are.',
    icon: Heart,
  },
];

const HowItWorks = () => (
  <section id="how-it-works" className="relative scroll-mt-24 overflow-hidden bg-white py-20 text-purple-950 sm:py-28">
    <div className="absolute -left-24 top-16 h-72 w-72 rounded-full bg-yellow-200/30 blur-3xl" />
    <div className="relative z-10 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="mx-auto mb-14 max-w-3xl text-center">
        <div className="mx-auto mb-6 flex h-12 w-12 items-center justify-center rounded-full bg-yellow-400 text-purple-950">
          <Sparkles className="h-6 w-6" />
        </div>
        <p className="mb-4 text-xs font-semibold uppercase tracking-[0.35em] text-purple-600">The path is yours</p>
        <h2 className="font-title text-4xl font-bold text-purple-900 sm:text-5xl">How It Works</h2>
        <p className="mt-6 text-xl font-semibold leading-8 text-purple-800/75">
          All 1 on 1 appointments take place virtually over Zoom.
        </p>
      </div>

      <div className="grid gap-5 md:grid-cols-3">
        {steps.map(({ number, title, description, icon: Icon }) => (
          <article key={number} className="relative rounded-2xl border border-purple-100 bg-[#f8f4ff] p-7">
            <span className="font-title text-5xl font-bold text-purple-200">{number}</span>
            <div className="mt-5 flex h-11 w-11 items-center justify-center rounded-full bg-purple-900 text-yellow-300">
              <Icon className="h-5 w-5" />
            </div>
            <h3 className="mt-5 font-subtitle text-xl font-bold text-purple-900">{title}</h3>
            <p className="mt-3 leading-7 text-purple-800/75">{description}</p>
          </article>
        ))}
      </div>

      <div className="mt-10 text-center">
        <Link
          to="/how-it-works"
          className="inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-[0.14em] text-purple-700 transition hover:text-purple-950"
        >
          See How It Works <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </div>
  </section>
);

export default HowItWorks;